import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { MessageService, TreeNode, TreeTableNode } from 'primeng/api';
import { of } from 'rxjs';
import { DataStateEnum } from 'src/app/enumeration/dataState.enum';
import { entite } from 'src/app/models/entite';
import { EntitebackService } from 'src/app/services/entite/entiteback.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TreeTableModule, TreeTableNodeUnSelectEvent } from 'primeng/treetable';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { FormVendeurComponent } from './form-vendeur/form-vendeur.component';
import { FormEntiteComponent } from './form-entite/form-entite.component';
import { FormProgrammeComponent } from './form-programme/form-programme.component';

interface Column {
  field: string;
  header: string;
}
interface NodeEvent {
  originalEvent: Event;
  node: TreeNode;
}
@Component({
  selector: 'app-page-entites',
  templateUrl: './page-entites.component.html',
  imports: [TreeTableModule, ButtonModule, CommonModule, DialogModule, ToastModule, FormsModule, FormVendeurComponent, FormEntiteComponent, FormProgrammeComponent],
  styleUrls: ['./page-entites.component.scss'],
  providers: [DialogService, MessageService],


})
export class PageEntitesComponent implements OnInit {

  files: any[] = []
  file: TreeTableNode<any> | TreeTableNode<any>[] | null = null;
  cols!: Column[];
  entitefilles: TreeNode[] = [];

  listentites: entite[] = [];
  listentitesNODE: TreeNode[] = [];
  list: entite[] = [];
  continentsNodes: TreeNode[] = [];
  listpere: entite[] = [];
  listperev: entite[] = [];
  listfinal: number[] = [];
  outOfTree = false;
  constructor(public router: Router, public messageService: MessageService, public share: shareOpeSevices, public dialogService: DialogService, private serv: EntitebackService) { }

  entiteForm: boolean = false;
  userForm: boolean = false;
  programForm: boolean = false;
  ref: DynamicDialogRef | undefined;
  classeIcon = "pi pi-angle-double-right";
  expanded: boolean = true;

  showUserForm() {
    this.userForm = true;
  }

  showEntiteForm() {
    this.share.addEntite = true;
  }
  onNodeSelect(event: any) {
    this.share.sendFicheEntite(event.node);
    this.router.navigate([`/fiche-entite`]);

  }
  OnNodeUnselect(event: TreeTableNodeUnSelectEvent) {

    this.messageService.add({ severity: 'warn', summary: 'Node Unselected', detail: "event.node.data.name" });

  }


  showProgramForm(event: any) {
    this.share.sendFicheEntite(event.node);
    this.share.programForm = true;
  }

  ngOnInit() {

    this.getEntites();
    this.cols = [
      { field: 'id', header: 'Id' },
      { field: 'name', header: 'Entités' },
      { field: 'address', header: 'Adresse' },
      { field: 'type', header: 'Type' },
      { field: 'exter', header: 'Ext/int.' },
      { field: 'axe', header: 'Axe' }
    ];


  }
  /*
  getEntites() {
    this.serv.getAllEntites().subscribe({
      next: ((data: entite[]) => {
        this.serv.getEntitesPeres().subscribe((resultat: entite[]) => {
          resultat.forEach((resul : entite) => {
          this.entitesToTreeNode(resul, data);
        });
          this.files = this.listentitesNODE;
          this.files[0].expanded = true;
        })
      }),
      error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
    }
    );
  }*/

  expandAllNodes(tree: any[], boo: boolean): void {
    tree.forEach(node => {
      node.expanded = boo;
      if (node.children && node.children.length) {
        this.expandAllNodes(node.children, boo);
      }
    });
  }


  toggleApplications() {
    if (this.files && this.files.length > 0) {
      this.files = [...this.files];
      let boo = this.expanded;
      this.classeIcon = boo ? "pi pi-angle-double-right" : "pi pi-angle-double-down";
      this.files.forEach(filesItem => {
                  filesItem.expanded = boo;
      });
      this.files.forEach(filesItem => {
                  this.expandAllNodes(filesItem.children, boo);
      });
      this.expanded = !this.expanded;
    }
  }

  getEntites() {
    let entities: entite[] = [];
    let resultat: entite[] = [];

    this.serv.getAllEntites()
      .subscribe({

        next: ((data: entite[]) => {
          entities = data;
        }),
        complete: (() => {
          this.serv.getEntitesPeres()
            .subscribe({

              next: ((data: entite[]) => {
                resultat = data;
              }),
              complete: (() => {

                resultat.forEach(resItem => {
                  this.entitesToTreeNode(resItem, entities);
                });

                this.files = this.listentitesNODE;
                this.files.forEach(filesItem => {
                  filesItem.expanded = true;
                });
              }),
              error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
            }
            );

        }),
        error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
      }
      );
  }

  entitesToTreeNode(entitess: entite, entitesfilles: entite[]) {
    if (entitess !== null) {
      this.listentitesNODE.push(this.entiteToTreeNode(entitess, entitesfilles));
    }
  }

  entiteToTreeNode(entitepere: entite, entitefille: entite[]): TreeNode {

    let entt: TreeNode[] = [];

    entitefille.forEach((resu: entite) => {
      if (_.isEqual(entitepere, resu.numPere)) {
        entt.push(this.entiteToTreeNode(resu, entitefille));
      }
    });
    entitefille.forEach((abv: entite) => {
      if (_.isEqual(entitepere, abv.numPere)) {

      }
    });
    return {
      data: {
        id: entitepere.numEntite,
        name: entitepere.libelle,
        address: this.transformValueNull(entitepere),
        type: entitepere.type,
        exter: this.transformStatutExt(entitepere.ext),
        axe: entitepere.axe
      },
      children: entt
    }
  }

  entitefille(myentite: entite): TreeNode {
    return {
      data: {
        id: myentite.numEntite,
        name: myentite.libelle,
        address: this.transformValueNull(myentite),
        type: myentite.type,
        exter: this.transformStatutExt(myentite.ext),
        axe: myentite.axe
      }
    }
  }

  transformStatutExt(char: number): string {
    if (char == 0) {
      return "Interne"
    }
    else return "Extrene"
  }
  transformValueNull(entite: entite): string {

    if ((entite.adresse1 == null && entite.adresse2 == null && entite.adresse3 == null
      && entite.codePostal == null && entite.ville == null)) {
      return ''
    }
    else return entite.adresse1 + ' ' + entite.adresse2 + ' ' + entite.adresse3 + ' ' + entite.codePostal + ' ' + entite.ville;

  }
  handleClose() {

    this.getEntites();
  }


}
